'use client';

import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/generics/data-display/button/Button';
import { Drawer } from '@/components/ui/generics/overlay/drawer/Drawer';

interface AuthSheetProps {
  /** true = viewport abaixo do desktop de 2 colunas (useIsMobileViewport). */
  isMobile: boolean;
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
  /** Rótulo do CTA que reabre o sheet dispensado (mobile). */
  launcherLabel: string;
  /** Aria label do fechamento do Drawer. */
  closeLabel: string;
  /** Wrapper usado no desktop (painel inline da página). */
  inlineClassName?: string;
  /**
   * Ícone sutil exibido no topo do sheet, abaixo do risco (grab handle) -
   * dinâmico por contexto/etapa (ex.: User → Lock → Scissors no wizard).
   */
  icon?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Painel de formulário das telas de auth: INLINE no desktop e Drawer bottom
 * (sheet) no mobile - mesmo padrão da agenda em viewport estreito: sem
 * título e sem botão fechar; dispensa clicando fora/ESC. O sheet nasce
 * FECHADO - abre apenas pelo launcher (CTA primário da página).
 */
export function AuthSheet({
  isMobile,
  open,
  onOpen,
  onClose,
  launcherLabel,
  closeLabel,
  inlineClassName,
  icon,
  children,
}: AuthSheetProps) {
  if (!isMobile) {
    return <div className={inlineClassName}>{children}</div>;
  }

  return (
    <>
      <Button
        type="button"
        variant="primary"
        size="lg"
        fullWidth
        onClick={onOpen}
        rightIcon={<ArrowRight size={16} aria-hidden="true" />}
      >
        {launcherLabel}
      </Button>
      <Drawer
        isOpen={open}
        onClose={onClose}
        side="bottom"
        hideCloseButton
        closeLabel={closeLabel}
        className="auth-sheet"
      >
        <div className="auth-sheet__content">
          {/* UM unico marcador no topo do sheet: o icone dinamico da etapa
              (faz o papel do risco/grab handle, sem duplicar elementos). */}
          {icon && (
            <span className="auth-sheet__icon" aria-hidden="true">
              {icon}
            </span>
          )}
          {children}
        </div>
      </Drawer>
    </>
  );
}
